<template>
  <div class="success-page">
    <Card dis-hover class="success-card">
      <div class="success-icon">
        <Icon type="ios-checkmark-circle" />
      </div>
      <div class="success-title">提交成功</div>
      <div class="success-desc">信息采集已提交完成。产品绑定后会显示在首页，点击产品即可查看检测进展和报告。</div>
      <div class="success-actions">
        <Button type="primary" long @click="goHome">返回首页查看产品</Button>
        <Button long class="success-actions__secondary" @click="goToReport">查询报告</Button>
      </div>
    </Card>
  </div>
</template>

<script>
export default {
  name: 'SubmitSuccess',
  methods: {
    goHome () {
      this.$router.replace({
        path: '/home',
        query: this.$route.query
      })
    },
    goToReport () {
      this.$router.replace({
        path: '/report',
        query: this.$route.query
      })
    }
  }
}
</script>

<style scoped>
.success-page {
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 64px 16px 40px;
  box-sizing: border-box;
  background: var(--wpc-bg);
}

.success-card {
  width: 100%;
  max-width: 520px;
  border: 1px solid #edf0f4;
  border-radius: var(--wpc-radius);
  text-align: center;
  padding: 28px 12px;
  box-shadow: none;
}

.success-icon {
  font-size: 64px;
  line-height: 1;
  color: var(--wpc-primary);
}

.success-title {
  margin-top: 16px;
  font-size: 28px;
  font-weight: 600;
  color: #1f2d3d;
}

.success-desc {
  margin: 16px auto 0;
  max-width: 380px;
  color: #63738a;
  line-height: 1.8;
  font-size: 15px;
}

.success-actions {
  margin-top: 28px;
}

.success-actions__secondary {
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/SubmitSuccess.vue